import Component from '.';
import Block from '@components/Layout/Block';

const _map = (block: any, test = false) => {
  return (
    <Block>
      <Component richText={block?.fields?.editor} />
    </Block>
  );
};

export default _map;
